SA.arraysEqual = function(arr1, arr2) {
    arr1 = Ext.Array.from(arr1);
    arr2 = Ext.Array.from(arr2);

    if (arr1.length !== arr2.length) {
        return false;
    }

    return arr1.every((arr1Item, index) => arr1Item === arr2[index]);
};

SA.Array = {
    divide(array, chunkSize) {
        var chunks = [];

        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize));
        }

        return chunks;
    },

    equalSets(array, otherArray) {
        var uniqued = Ext.Array.unique(array),
            otherUniqued = Ext.Array.unique(otherArray),
            sameCounts = uniqued.length === otherUniqued.length;

        return sameCounts && uniqued.every(item => otherUniqued.includes(item));
    },

    flatMap(array, callback) {
        var result = [];

        array.map((item, index) => callback(item, index))
            .map(item => (Array.isArray(item) ? item : [item]))
            .forEach(item => result.push(...item));

        return result;
    },

    getLast(array) {
        return array[array.length - 1];
    },

    group(array, predicate) {
        var result = {};

        array.forEach(item => {
            var entry = (result[predicate(item)] ??= []);

            entry.push(item);
        });

        return Object.entries(result);
    },

    hasDuplicates(array) {
        return array.length > new Set(array).size;
    },

    overlaps(...arrays) {
        return Ext.Array.intersect(...arrays).length > 0;
    },

    toObject(array, {keyBy: key}) {
        return Object.fromEntries(array.map(item => [item[key], item]));
    },

    unique(array) {
        var {flatten, unique} = Ext.Array;

        return unique(flatten(array));
    }
};